import { createAuthClient } from "better-auth/react";
import { convexClient, crossDomainClient } from "@convex-dev/better-auth/client/plugins";
import { env } from "@/shared/lib/env";

/**
 * Better Auth client. Talks to the Better Auth handlers we mounted on Convex
 * (`convex/http.ts`). Cross-domain plugin is required because the SPA origin
 * differs from the Convex deployment origin.
 */
export const authClient = createAuthClient({
  baseURL: env.VITE_CONVEX_SITE_URL,
  plugins: [convexClient(), crossDomainClient()],
});
